import { formatINR } from "@/utils/goldSilverParser";
import { useEffect, useState } from "react";

export default function GoldSilverFlipCard({priceData=null}) {
    const colorSelector = (isGold) => {
        return {
            lightBgL: isGold ? "bg-[#F9F5E6]" : "bg-[#E5E7EB]/90",
            border: isGold ? "border-[#F0E6C0]" : "border-[#E5E7EB]",
            lightBg: isGold ? "bg-[#F0E6C0]/40" : "bg-[#E5E7EB]/50",
            gradient: isGold ? "bg-[linear-gradient(90deg,#F0A500_0%,#FFDF10_50%,#F4B000_100%)]" : "bg-[linear-gradient(90deg,#C8C8C8_0%,#F4F4F4_48%,#BDBDBD_100%)]",
        };
    }

    const [currentCard, setCurrentCard] = useState(priceData?.gold);
    const colors = colorSelector(currentCard?.trend24? true : false);
    useEffect(()=>{
        const interval = setInterval(()=>{
            setCurrentCard((prevCard)=>{
                if(prevCard?.trend24){
                    return priceData?.silver;
                }else{
                    return priceData?.gold;
                }
            })
        }, 2000);
        return () => clearInterval(interval);
    })

    return (
           <a href={currentCard?.pageHref} className={`min-w-[104px]  shrink-0 flex flex-col items-end gap-1.5 whitespace-nowrap`}>
                <div className="flex items-center gap-1">
                    <div className={`w-3 h-3 rounded-full shrink-0 ${colors.gradient}`}></div>
                    <span className="text-xs">{currentCard?.trend24? "24K Gold" : "Silver"}</span>
                </div>
                <span className="text-md font-bold">{currentCard?.trend24? formatINR(currentCard?.oneGram?.carat24)+"/g" : formatINR(currentCard?.tenGram)+"/10g"}</span>
           </a>
    )
}